import { normalizeText } from "@/common/utils/formatters";
import { format, parse } from "date-fns";
import { MissionSchema } from "../schemas/mission.schema";
import { parseRequirementQuantity } from "../utils/missionMapper";
import { OPTIONAL_QUANTITY_LABELS } from "../constants/optionalQuantityLabels.constant";

export class MissionFormTransformer {
  static parseDateField(value?: string) {
    if (!value) return undefined;
    try {
      const parsed = parse(value, "dd/MM/yyyy", new Date());
      return format(parsed, "yyyy-MM-dd");
    } catch {
      return value;
    }
  }

  private static isQuantityOptional(label?: string) {
    const normalized = normalizeText(label);
    if (!normalized) return false;
    return OPTIONAL_QUANTITY_LABELS.some((text) => normalized.includes(text));
  }

  static resolveRequirementQuantity(
    condition: MissionSchema["conditions"][number],
  ) {
    const parsed = parseRequirementQuantity(condition.value_label);
    if (parsed > 0) return parsed;
    return MissionFormTransformer.isQuantityOptional(condition.type_label)
      ? 1
      : parsed;
  }
}
